import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconAssigned(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 16H5V5h14v14ZM12 6c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3ZM6 16.47V18h12v-1.53c0-2.5-3.97-3.58-6-3.58s-6 1.07-6 3.58Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
